import type { PostgrestError } from '@supabase/supabase-js'
import { supabase } from '@/lib/supabase'
import { PermanentError, registerOutboxHandler } from './outbox'

/**
 * Network failures are retried; anything the server rejected on purpose (permission, validation,
 * constraint) will never succeed on retry, so it is parked for the user to see.
 */
export function throwIfError(error: PostgrestError | null) {
  if (!error) return
  const permanent = /^(42|22|23|P0)/.test(error.code ?? '')
  if (permanent) throw new PermanentError(error.message)
  throw new Error(error.message)
}

export type UpdatePrefsPayload = { userId: string; notification_prefs: Record<string, unknown> }

/** Handlers for every queued write. Phase 1 adds Relux submit, uploads, outcomes and visits. */
export function registerOutboxHandlers() {
  registerOutboxHandler('profile.update_prefs', async (item) => {
    const payload = item.payload as UpdatePrefsPayload
    const { error } = await supabase
      .from('profiles')
      .update({ notification_prefs: payload.notification_prefs })
      .eq('id', payload.userId)
    throwIfError(error)
  })
}
